<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
.staff-service-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
}

.staff-info {
    min-width: 0;
    padding-right: 12px;
}

.staff-info h6 {
    margin: 0 0 5px;
    font-size: 15px;
    font-weight: 600;
    color: #343a40;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.staff-info span {
    font-size: 12px;
    color: #6c757d;
}

/* Service counter */

.staff-services {
    width: 90px;
    height: 58px;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
    color: #fff;
}

.staff-services strong {
    font-size: 17px;
    font-weight: 700;
    line-height: 18px;
}

.staff-services small {
    font-size: 8px;
    text-transform: uppercase;
    line-height: 10px;
}


/* Success */

.success-card {
    border-left: 3px solid #198754;
}

.success-card .staff-services {
    background: #198754;
}


/* Primary */

.primary-card {
    border-left: 3px solid #0d6efd;
}

.primary-card .staff-services {
    background: #0d6efd;
}


/* Warning */

.warning-card {
    border-left: 3px solid #ffc107;
}

.warning-card .staff-services {
    background: #ffc107;
    color: #212529;
}


/* Danger */

.danger-card {
    border-left: 3px solid #dc3545;
}

.danger-card .staff-services {
    background: #dc3545;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Branch Sales Report's</h3>
                    <span></span>
                   </div>
                </div>
            </div>
        </div>

      <div class="row">

    <!-- Success -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card success-card">

            <div class="staff-info">
                <h6>{{ dataz.todays.name }}</h6>
                <p class="text-success">Best of Today</p>
            </div>

            <div class="staff-services">
                <strong><PriceFormat :Price="dataz.todays.total"/></strong>
                <small>SALES</small>
            </div>

        </div>
    </div>

    <!-- Primary -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card primary-card">

            <div class="staff-info">
                <h6>{{ dataz.day7.name }}</h6>
                
                <p class="text-primary">Best of the Weak</p>
            </div>

            <div class="staff-services">
                <strong><PriceFormat :Price="dataz.day7.total"/></strong>
                <small>SALES</small>
            </div>

        </div>
    </div>

    <!-- Warning -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card warning-card">

            <div class="staff-info">
               <h6>{{ dataz.day30.name }}</h6>
             
                <p class="text-warning">Best of the Month</p>
            </div>

            <div class="staff-services">
                <strong><PriceFormat :Price="dataz.day30.total"/></strong>
                <small>SALES</small>
            </div>

        </div>
    </div>

    <!-- Danger -->
    <div class="col-12 col-sm-6 col-lg-3 mb-3">
        <div class="staff-service-card danger-card">

            <div class="staff-info">
              <h6>All Branches</h6>
                <p class="text-danger">Monthly Sales</p>
            </div>

            <div class="staff-services">
                <strong><PriceFormat :Price="month_total"/></strong>
                <small>SALES</small>
            </div>

        </div>
    </div>

</div>

        <div class="row">
            <div class="col-12">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.search_staff"
                                                class="form-control"
                                                placeholder="Search to filter">
                        </div>
                        
                           <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid"></div>
                           <div v-if="user.role == 4" class="col-sm-12 col-md-6 col-12 stretch-card col-grid"></div>
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                  
                    <div  v-if="user.role < 4" class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterSales" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                         
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                         
                        </div>
                        <div class="col-sm-12 col-md-3"></div>
                        <div class="col-sm-12 col-md-6">
                               <div class="table-responsive">
                                
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                             <th>No</th>
                                            <th> Branch Name </th>
                                            <th> Total Sales </th>
                                            
                                           
                                        </tr>
                                    </thead>
                                    <tbody id="staff-list">

                                        <tr v-for="(staff, index) in paginatedStaffs" :key="staff.id"  id="staff_{{this.id}}">
                                             <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                                           
                                            <td> {{staff.name}}</td>
                                             <td class="text-center">
                                                <label class="badge badge-dark"><PriceFormat :Price="staff.total"/></label>
                                            </td>
                                           
                                        </tr>
                                     
                                    </tbody>
                                </table>
                            </div>
                                                       <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                        <div class="col-sm-12 col-md-3"></div>
                    </div>
               
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            search_staff:"",
            heading:"To Days Sale's Reports Total is TZS :",
            month_total:0,
            staffs:[],
            og_staffs:[],
            dataz:{
              todays:{name:"",total:0},
              day7:{name:"",total:0},
              day30:{name:"",total:0},
            },
            fdate:"",
            tdate:"",
            currentPage: 1,
            perPage: 20,
            user: this.$attrs.user
        };
    },
    methods: {

        async getSales() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/sales/branches-sales")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.staffs = response.data.sales;
                this.og_staffs = response.data.sales
                this.dataz = response.data.dataz
                this.month_total = response.data.month_total

                this.heading = "To Days Sale's Reports Total is TZS :"+Number(response.data.total || 0).toLocaleString();

               /// console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async filterSales(){

             this.loading = true

          var fdate = this.fdate
          var tdate = this.tdate

          var response = await axios
              .post(this.$store.state.api_url + "/sales/filter-branches-sales", {fdate, tdate})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.staffs = response.data.sales;
                this.og_staffs = response.data.sales
               
                this.heading = "Branches Sales Reports From ("+fdate+" To "+tdate+") Total is TZS :"+Number(response.data.total || 0).toLocaleString();
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedStaffs() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.staffs.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.staffs.length / this.perPage)
  },
  

},
    watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) ||
                    (branch.region && branch.region.toLowerCase().includes(term))
                )
            })
        },


        search_staff(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.staffs = this.og_staffs
                return
            }

            this.staffs = this.og_staffs.filter(staff => {

                return (
                    (staff.name && staff.name.toLowerCase().includes(term)) ||
                    (staff.region && staff.region.toLowerCase().includes(term)) ||
                    (staff.district && staff.district.toLowerCase().includes(term)) ||
                    (staff.location && staff.location.toLowerCase().includes(term)) ||
                    (staff.total && staff.total.toLowerCase().includes(term))
                )
            })
        }
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getSales()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
